import { render } from "./SwiperVideo.vue?vue&type=template&id=2ce9a318"
import script from "./SwiperVideo.vue?vue&type=script&lang=js"
export * from "./SwiperVideo.vue?vue&type=script&lang=js"

import "./SwiperVideo.vue?vue&type=style&index=0&id=2ce9a318&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__